export const REGEXP_PATIENT_PHONE = /^05\d-[1-9]\d{6}$/;
export const REGEXP_PATIENT_ID_NUMBER = /^\d{8,9}$/;
